
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'admin': `Administration`,
'admin.menu.audit': `Audit Logs`,
'admin.menu.directory-auth': `Directory Authentication`,
'admin.menu.identity-providers': `Identity &amp; Authentication Providers`,
'admin.menu.ip-allowlist': `IP Allowlist`,
'admin.menu.organization-settings': `Organization Settings`,
'admin.menu.roles': `Roles`,
'admin.menu.scim-tokens': `SCIM Tokens`,
'admin.menu.site-admin': `Site Administration`,
'admin.menu.site-admin.create': `Create Site`,
'admin.menu.user-groups': `User Groups`,
'admin.menu.users': `User Management`,
'admin.menu.workload-identities': `Workload Identities`,
'ai-coworkers.menu.agents.deployment': `Deployment`,
'ai-coworkers.menu.agents.events': `Events`,
'ai-coworkers.menu.control': `Protection`,
'ai-coworkers.menu.control.exceptions': `Exception Requests`,
'ai-coworkers.menu.control.policies': `Policies`,
'ai-coworkers.menu.control.yara-rules': `YARA Rules`,
'ai-coworkers.menu.dashboards': `Dashboard`,
'ai-coworkers.menu.intelligence': `Intelligence`,
'ai-coworkers.menu.intelligence.coding-sessions': `AI Sessions`,
'ai-coworkers.menu.inventory': `Visibility`,
'ai-coworkers.menu.inventory.agent-skills': `Agent Skills`,
'ai-coworkers.menu.inventory.agents': `AI Agents`,
'ai-coworkers.menu.inventory.endpoints': `Endpoints`,
'ai-coworkers.menu.inventory.mcp-servers': `MCP Servers`,
'ai-coworkers.menu.inventory.model-endpoints': `LLM Endpoints`,
'ai-coworkers.menu.settings': `Settings`,
'ai-coworkers.menu.settings.administration': `Administration`,
'ai-coworkers.menu.settings.connectors': `Connectors`,
'ai-coworkers.menu.settings.license': `License &amp; Usage`,
'ai-coworkers.menu.settings.update-strategy': `Update Strategy`,
'analytics': `Analytics`,
'appliance': `Appliance`,
'auditing': `Auditing`,
'breadcrumbNavLabel': `Breadcrumb`,
'breadcrumbOverflowLabel': `Show more breadcrumbs`,
'computer-groups': `Computer Groups`,
'computers': `Computers`,
'configuration': `Configuration`,
'dashboard': `Dashboards`,
'downloads': `Consoles &amp; Downloads`,
'entitle.menu.accessReview': `Overview`,
'entitle.menu.auditLogs': `Audit logs`,
'entitle.menu.bundles': `Bundles`,
'entitle.menu.identityGraph': `Permissions`,
'entitle.menu.integrations': `Integrations`,
'entitle.menu.policies': `Birthright policies`,
'entitle.menu.profile': `My settings`,
'entitle.menu.requests': `Requests`,
'entitle.menu.requestsLog': `Request history`,
'entitle.menu.settings': `Org settings`,
'entitle.menu.tasks': `Tasks`,
'entitle.menu.users': `Users`,
'entitle.menu.workflows': `Approval workflows`,
'epml.menu.audit': `Audit`,
'epml.menu.consoleAccess': `Console Access`,
'epml.menu.consoleAudit': `Console Audit`,
'epml.menu.directoryServices': `Directory Services`,
'epml.menu.endpoints': `Endpoint Management`,
'epml.menu.epmlSettings': `EPML Settings`,
'epml.menu.events': `Events`,
'epml.menu.explore': `Explore`,
'epml.menu.installers': `Installers`,
'epml.menu.linuxHostAuth': `Linux Host Authentication`,
'epml.menu.policy': `Policy`,
'epml.menu.roles': `Roles`,
'epml.menu.searchAndReplay': `Search and Replay`,
'epml.menu.settings': `Settings`,
'epml.menu.siemConnections': `SIEM Connections`,
'epml.menu.unifiedSearch': `Unified Search`,
'home': `Home`,
'insights.menu.accounts': `Accounts`,
'insights.menu.agentInventory': `Agent Inventory`,
'insights.menu.aiAgents': `AI Agents`,
'insights.menu.aiSecurity': `AI Security`,
'insights.menu.aiThreatDetection': `Threat Detection`,
'insights.menu.aiThreatPolicy': `Threat Policy`,
'insights.menu.connectors': `Connectors`,
'insights.menu.dashboard': `Dashboard`,
'insights.menu.detections': `Detections`,
'insights.menu.entitlements': `Entitlements`,
'insights.menu.exclusionRules': `Exclusion Rules`,
'insights.menu.identities': `Identities`,
'insights.menu.identitiesPrivileges': `Identities and Privileges`,
'insights.menu.insights': `Insights`,
'insights.menu.integrations': `Integrations`,
'insights.menu.integrationsConnections': `Integrations and Connections`,
'insights.menu.recommendations': `Recommendations`,
'insights.menu.reporting': `Reporting`,
'insights.menu.secrets': `Secrets`,
'insights.menu.secretsInventory': `Secrets Inventory`,
'insights.menu.secretsSecurity': `Secrets Security`,
'jit-access-management': `JIT Access Management`,
'jump': `Asset Management`,
'localization': `Localization`,
'login.account_policy.index': `Account Policies`,
'login.api_account.index': `API Configuration`,
'login.appliance.index': `Appliance`,
'login.business_hours.index': `Schedule`,
'login.callback_button.index': `Support Buttons`,
'login.canned_message.index': `Canned Messages`,
'login.canned_script.index': `Canned Scripts`,
'login.compliance.index': `Compliance`,
'login.custom_fields.index': `Custom Fields`,
'login.custom_links.index': `Custom Links`,
'login.customer_notice.index': `Customer Notices`,
'login.dashboard.getNetworkRestrictions': `Network Restrictions`,
'login.dashboard.index': `Dashboards`,
'login.discovery.index': `Discovery`,
'login.downloads.drivers.index': `Drivers`,
'login.downloads.rep.index': `Rep Console`,
'login.duplicate_pinned_clients_reporting.index': `Duplicate Jump Clients`,
'login.email_settings.index': `Email Configuration`,
'login.endpoint_automation.index': `Endpoint Automation`,
'login.exit_survey.index': `Exit Surveys`,
'login.file_store.index': `File Store`,
'login.group_policy.index': `Group Policies`,
'login.html_template.index': `HTML Templates`,
'login.ios_profile.index': `iOS Configuration`,
'login.issue.index': `Issues`,
'login.jump_item_reporting.index': `Asset`,
'login.jump_item_roles.index': `Asset Roles`,
'login.jump_item.index': `Assets`,
'login.jump_policies.index': `Asset Policies`,
'login.kerberos_keytab.index': `Kerberos Keytab`,
'login.license_reporting.index': `Licensing`,
'login.licensing.index': `Licensing`,
'login.mcp_config.index': `MCP Server`,
'login.ms_teams.index': `MS Teams`,
'login.my_account.profile.index': `Profile`,
'login.my_account.security.index': `Security`,
'login.nls.real_time_chat.index': `Real-Time Chat`,
'login.outbound_event.index': `Outbound Events`,
'login.pinned_clients.index': `Jump Clients`,
'login.public_site.index': `Public Sites`,
'login.push_agent.index': `Gateway`,
'login.rep_invite.index': `Rep Invite`,
'login.rep_profile.index': `Rep Console Settings`,
'login.sd_client.index': `Customer Client`,
'login.sd_general.index': `Options`,
'login.security_providers.index': `Security Providers`,
'login.security_settings.index': `Security`,
'login.session_policy.index': `Session Policies`,
'login.session_report.index': `Support`,
'login.settings.index': `Software`,
'login.shared_jump_groups.index': `Asset Groups`,
'login.site_settings.index': `Site Configuration`,
'login.skill.index': `Skills`,
'login.special_action.index': `Special Actions`,
'login.status_representatives.index': `Representatives`,
'login.status.index': `Information`,
'login.support_settings.index': `Support`,
'login.syslog_reporting.index': `Syslog`,
'login.team.index': `Support Teams`,
'login.user.index': `Users`,
'login.vault_account_group.index': `Account Groups`,
'login.vault_account.index': `Accounts`,
'login.vault_domain.index': `Domains`,
'login.vault_endpoint.index': `Endpoints`,
'login.vault_options.index': `Options`,
'login.vault_password_safe_connection.index': `Connections`,
'login.vault_reporting.index': `Vault`,
'management': `Management`,
'management-rules': `Management Rules`,
'menu-phantom-labs': `Phantom Labs`,
'my_account': `My Account`,
'pmc.audit': `Audit`,
'pmc.explore': `Explore`,
'pmc.settings': `Settings`,
'policies': `Policies`,
'public_site': `Public Portals`,
'rep_console': `Console Settings`,
'reporting': `Reports`,
's352719d86112de9a': `Help`,
's3741f519c32ac391': `New`,
's3d64ea063be4c9f2': `Unified Auditing`,
's416434bef0c17abc': `Unable to load the menu. Close and reopen it to try again.`,
's417b90913e05bc17': `Preview`,
's49730f3d5751a433': `Loading...`,
's4c9351ce0cc28196': `Product navigation`,
's596a144afb429d94': `More Products`,
's5e8250fb85d64c23': `Close`,
's691d6163aaabb69b': `User Profile`,
's6abb1cd87fe0114e': `Home`,
's6d8c02aee480af7a': `Menu`,
's714ea1e6436002a2': `Pin navigation open`,
's76902262e33e63b5': `Toggle sidebar navigation`,
'sd': `Configuration`,
'sffe2914d4b7c91ee': `Early Access`,
'sitemenu.about': `About`,
'sitemenu.analytics': `Analytics &amp; Reporting`,
'sitemenu.analyticsandreporting.viewallreports': `View All Reports`,
'sitemenu.analyticsandreportingtrident': `Analytics &amp; Reporting`,
'sitemenu.assets': `Assets`,
'sitemenu.configuration': `Configuration`,
'sitemenu.dashboard': `Dashboard`,
'sitemenu.dashboard.dynamicdashboard': `Dashboard (Preview)`,
'sitemenu.discovery': `Discovery`,
'sitemenu.discovery.activeandcompletedscans': `Active/Completed Scans`,
'sitemenu.discovery.discoveryscanners': `Discovery Scanners`,
'sitemenu.discovery.newdiscoveryscan': `Run a New Discovery Scan`,
'sitemenu.discovery.scheduledscans': `Scheduled Scans`,
'sitemenu.managedaccounts': `Managed Accounts`,
'sitemenu.managedsystems': `Managed Systems`,
'sitemenu.passwordsafe': `Password Safe`,
'sitemenu.passwordsafe.accounts': `Accounts`,
'sitemenu.passwordsafe.activesessions': `Active Sessions`,
'sitemenu.passwordsafe.administratorsessions': `Admin Sessions`,
'sitemenu.passwordsafe.approvals': `Approvals`,
'sitemenu.passwordsafe.completedsessions': `Completed Sessions`,
'sitemenu.smartrules': `Smart Rules`,
'sitemenu.teampasswords': `Secrets Safe`,
'siteSelectorDataResidency': `data residency`,
'siteSelectorLabel': `Site`,
'siteSelectorNoSitesFound': `No sites found`,
'siteSelectorSearchPlaceholder': `Search sites`,
'status': `Status`,
'user-management': `User Management`,
'users': `Users &amp; Security`,
'vault': `Vault`,
    };
  